import { createAction, props } from '@ngrx/store';
import { PatientLetter } from '../../models/patient-letter';

export const getPatientLetters = createAction('[Letters] Get Letters');
export const getPatientLettersSuccess = createAction(
  '[Letters] Get Letters Success',
  props<{ letters: PatientLetter[] }>()
);
export const getPatientLettersFailure = createAction('[Letters] Get Letters Failure', props<{ error: unknown }>());

export const getPatientLetter = createAction('[Letters] Get Letter', props<{ letterId: number }>());
export const getPatientLetterSuccess = createAction('[Letters] Get Letter Success', props<{ letter: PatientLetter }>());
export const getPatientLetterFailure = createAction('[Letters] Get Letter Failure', props<{ error: unknown }>());

export const recordPatientLetterPrintEvent = createAction(
  '[Letters] Record Print Event',
  props<{ patientId: number; patientLetterId: number }>()
);

export const recordPatientLetterPrintEventSuccess = createAction('[Letters] Record Print Event Success');

export const recordPatientLetterPrintEventFailure = createAction(
  '[Letters] Record Print Event Failure',
  props<{ error: unknown }>()
);
